export class FilterItemValueDto {
  constructor(
        public value: string,
        public title: string,
        public titleKey: string,
        public type: string,
        public isChecked: boolean,
        public counter: number,
        public position: number) { }
}